<template>
  <div style="height: 100%;overflow: auto;">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="lastHeaderColumns">
        <li class="main-table-cell">
          <div class="main-table-cell-wrap">
            <span class="main-table-txt">调用记录</span>
          </div>
        </li>
      </template>
      <template slot="lastBodyColumns" slot-scope="props">
        <li class="main-table-cell">
          <div class="main-table-cell-wrap">
          <span class="main-table-txt">
            <grid-menu-a
              style="color: #677de0;"
              @menu-click="changeRouterToRecord(props.row)"
              name="调用记录"
            >
            </grid-menu-a>
          </span>
          </div>
        </li>
      </template>
      <template slot="topSelectMenus">
        <grid-menu-a
          name="开启触发器"
          style="margin-right: 3px;"
          class="btn btn-hollow-dark"
          @menu-click="startTrigger"
        >
        </grid-menu-a>
        <grid-menu-a
          name="暂停触发器"
          style="margin-right: 3px;"
          class="btn btn-hollow-dark"
          @menu-click="suspendTrigger"
        >
        </grid-menu-a>
      </template>
    </grid>
  </div>
</template>

<script>
  import Grid from '../../../../components/grid/grid'
  import GridMenuA from '../../../../components/grid-menu/grid-menu-a'
  import util from '@/libs/util'
  export default {
    components: {
      Grid,
      GridMenuA
    },
    name: 'schedule-trigger',
    data() {
      return {
        gridConfigUrl: '/entity/scheduler/scheduleTriggerManage/abstractGrid',
        jobKey: this.$route.query.jobKey,
        clientId: this.$route.query.clientId
      }
    },
    methods: {
      changeRouterToRecord: function (row) {
        util.changeRouter(this, {
          name: 'scheduleRecord',
          query: {
            jobKey: row.jobKey,
            triggerKey: row.triggerKey,
            clientId: this.clientId
          }
        })
      },
      startTrigger: function () {
        let keys = this.$refs.myGrid.checkedRows
        if (keys.length !== 1) {
          this.$notify.warning({title: '警告', message: '请选择一条数据'})
          return
        }
        this.$confirm('确定开启触发器吗？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          util.ajax.put('/entity/scheduler/scheduleTriggerManage/job/' + this.jobKey + '/trigger/' + keys[0] + '/status?clientId=' + this.clientId + '&isStart=true').then(res => {
            if (res.data.meta.errCode === 0) {
              this.$notify.success({title: '成功', message: '开启成功'})
              this.$refs.myGrid.loadTableData()
            } else {
              this.$notify.warning({title: '错误', message: res.data.meta.errMsg})
            }
          }).catch(err => {
            console.error(err)
            this.$notify.error({title: '错误', message: '系统错误'})
          })
        }).catch()
      },
      suspendTrigger: function () {
        let keys = this.$refs.myGrid.checkedRows
        if (keys.length !== 1) {
          this.$notify.warning({title: '警告', message: '请选择一条数据'})
          return
        }
        this.$confirm('确定暂停触发器吗？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          util.ajax.put('/entity/scheduler/scheduleTriggerManage/job/' + this.jobKey + '/trigger/' + keys[0] + '/status?clientId=' + this.clientId + '&isStart=false').then(res => {
            if (res.data.meta.errCode === 0) {
              this.$notify.success({title: '成功', message: '暂停成功'})
              this.$refs.myGrid.loadTableData()
            } else {
              this.$notify.warning({title: '错误', message: res.data.meta.errMsg})
            }
          }).catch(err => {
            console.error(err)
            this.$notify.error({title: '错误', message: '系统错误'})
          })
        }).catch()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/components/grid/scheduler/schedule-trigger.vue